module.exports = __webpack_public_path__ + "static/card10-f1950ffd0a5b88b8d23b10f8f65dbb51.png";